import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
    loading: false,
    jobs: {
        rows: [],
        order: "asc",
        orderBy: "",
        limit: 50,
        search: "",
        count: 0,
        offset: 0,
    },
    jobToDelete: null,
};

const ReducerSlice = createSlice({
    name: "job",
    initialState: initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload || false;
        },
        setJobs(state, action) {
            if (action.payload.rows) {
                state.jobs.rows = action.payload.rows;
            }
            if (action.payload.count !== undefined && action.payload.count !== null) {
                state.jobs.count = action.payload.count;
            }
            if (action.payload.offset !== undefined && action.payload.offset !== null) {
                state.jobs.offset = action.payload.offset;
            }
            if (action.payload.limit !== undefined && action.payload.limit !== null) {
                state.jobs.limit = action.payload.limit;
            }
            if (action.payload.search !== undefined && action.payload.search !== null) {
                state.jobs.search = action.payload.search;
            }
        },
        setJobToDelete(state, action) {
            state.jobToDelete = action.payload;
        },
        deleteJob(state) {
            state.jobs.rows = state.jobs.rows.filter(
                (job: any) => job.id !== state.jobToDelete.id
            );
        },
    },
});

export const {
    setLoading,
    setJobs,
    setJobToDelete,
    deleteJob,
} = ReducerSlice.actions;

export default ReducerSlice.reducer;